import AboutPage from './about';
import DevPage from './dev';
import HomePage from './home';
import AppPage from '../App';
import BlogPage from './blog';
import ContactPage from './contact';

export default {
    AppPage,
    HomePage,
    DevPage,
    AboutPage,
    BlogPage,
    ContactPage
} as any;
